import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import Loader from 'ui-component/Loader';
import { useCloudRestApiAccess } from 'contexts/CloudRestApiAccessContext';
import { isSupportAgentTokenAccessRestricted } from './cloudRestApiTokenAccess';

/**
 * Blocks Cloud REST API routes when feature 259 + cloudRESTSupport are not both enabled,
 * and when a support agent is impersonating a customer (PRJCBUGEN-63941) — even though the
 * impersonated customer's own role would otherwise be allowed onto this route.
 */
export default function CloudRestApiGate({ children }) {
  const { loading, enabled } = useCloudRestApiAccess();
  const location = useLocation();
  const params = useParams();

  const fallback =
    location.pathname.includes('/organization/') && params.orgName
      ? `/organization/${encodeURIComponent(params.orgName)}/administration/users`
      : '/mspHome/administration/users';

  if (loading) {
    return <Loader />;
  }
  if (!enabled || isSupportAgentTokenAccessRestricted()) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
